import { Download } from 'iconoir-react';
import { FunctionComponent } from 'react';

import { IconPropsInterface } from './Icon.types';

const DownloadIcon: FunctionComponent<IconPropsInterface> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => <Download width={size} height={size} color={color} {...rest} />;

DownloadIcon.displayName = 'DownloadIcon';

export default DownloadIcon;
